<template>
  <v-dialog persistent v-model="dialog" width="650">
    <v-card>
      <v-card-title class="headline" primary-title>{{ dialogTitle }}</v-card-title>
      <v-divider></v-divider>
      <v-card-text>
        <v-container grid-list-md pa-0>
          <v-form ref="form" lazy-validation>
            <v-layout wrap>
              <v-flex xs12>
                <v-text-field
                  box
                  required
                  label="Nome"
                  :rules="[(v) => !!v || 'O nome é obrigatório!']"
                  v-model="name"
                ></v-text-field>
              </v-flex>
            </v-layout>
          </v-form>
        </v-container>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions>
        <strong v-if="failureText != null" class="red--text ml-2 simulation">{{
          failureText
        }}</strong>
        <v-spacer></v-spacer>
        <v-btn color="primary" outline @click="$emit('update:dialog', false)">
          Fechar
        </v-btn>
        <v-btn
          color="primary"
          class="elevation-1"
          :loading="loading"
          :disabled="!name || loading"
          @click="save"
        >
          Salvar
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import tasksService from "@/services/tasks";
import treeService from "@/services/consolidation-tree/consolidation-tree";

export default {
  props: {
    dialog: {
      type: Boolean,
      default: false,
    },
    defaultName: {
      type: String,
      default: "",
    },
    creditorId: {
      type: Number,
      default: null,
    },
    debtBase: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      name: "",
      loading: false,
      failureText: null,
    };
  },
  computed: {
    isEditing() {
      return !!this.debtBase;
    },
    dialogTitle() {
      return this.isEditing ? "Editar árvore" : "Nova árvore";
    },
  },
  watch: {
    dialog(val) {
      if (!val) return;
      this.failureText = null;
      this.name = this.isEditing ? this.debtBase.name : this.defaultName;
    },
  },
  methods: {
    save() {
      return this.isEditing ? this.editDebtBase() : this.addDebtBase();
    },
    async addDebtBase() {
      this.loading = true;
      let debtBase = await treeService.addDebtBase({
        name: this.name,
        creditor_id: this.creditorId,
      });

      this.$emit("updateDebtBase", debtBase);

      // cria o nó raiz
      let debtNode = await treeService.createNode({
        debt_base_id: debtBase.id,
        parent_id: null,
        type: "ALL",
        value: {},
        name: "Carteira total",
      });
      await this.checkCreation(debtNode.task_id);
    },
    async editDebtBase() {
      this.loading = true;
      try {
        const updated = await treeService.patchDebtBase(this.debtBase.id, { name: this.name });
        this.$emit("debtBaseEdited", updated);
        this.$emit("update:dialog", false);
      } catch (err) {
        this.failureText = "Houve um erro ao editar a árvore";
        console.error(err);
      } finally {
        this.loading = false;
      }
    },
    async checkCreation(taskId) {
      var interval = setInterval(async () => {
        tasksService
          .get(taskId)
          .then(async (res) => {
            if (res.state == "SUCCESS") {
              clearInterval(interval);

              this.$emit("renderTree");
              this.$emit("update:dialog", false);

              this.loading = false;
            } else if (res.state == "FAILURE") {
              this.failureText = "Houve um erro na criação do nó";
              clearInterval(interval);
              this.loading = false;
            }
          })
          .catch((err) => {
            this.failureText = "Houve um erro na criação do nó";
            console.error(err);
            clearInterval(interval);
            this.loading = false;
          });
      }, 1000);
    },
  },
};
</script>

<style></style>
